interface TruncationNoticeProps {
  readonly shown: number;
  readonly total: number;
}

/**
 * Says when the response carried only part of the policy's claims.
 *
 * The grid searches, sorts and paginates client-side over whatever it was given, so a cap that went
 * unannounced would look exactly like a complete history — the provider would read "28 claims" and
 * believe it.
 */
export function TruncationNotice({ shown, total }: TruncationNoticeProps): React.JSX.Element {
  return (
    <p
      role="status"
      className="border-gold-200 bg-gold-50 text-gold-800 mt-4 rounded-md border px-4 py-3 text-[13px]"
    >
      This policy has {total} claims and the {shown} most recent are shown. Narrow the date range to
      see the rest.
    </p>
  );
}
